import { PlusOutlined } from '@ant-design/icons';

import { CenterFlex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import Typo from '@/components/Typography/Typo';
import AMP_KEYS from '@/configs/amp-track-keys';
import { useFeedbackTerminology } from '@/entities/workspace';
import {
  FEEDBACK_GALLERY_DEFAULT_TITLE,
  getDefaultFilterSet,
  getFeedbackGalleryTitle,
} from '@/features/(dashboard)/feedback-gallery/model/constants';
import useColor from '@/hooks/domain/useColor';
import useDashboard2Store from '@/stores/Dashboard2Store';
import { track } from '@/utils/track/track';

import AddChartDashboardMenu from './AddChartDashboardMenu/AddChartDashboardMenu';

type DashboardAddChartCardProps = {
  dashboardId: string;
  height: string;
  currentCharts?: string[];
  rowCount?: number;
};

const DashboardAddChartCard = (props: DashboardAddChartCardProps) => {
  const color = useColor();
  const { replaceFeedbackTerminology } = useFeedbackTerminology();
  const setPendingFeedbackGallery = useDashboard2Store(
    (state) => state.setPendingFeedbackGallery,
  );
  const setEditingState = useDashboard2Store((state) => state.setEditingState);

  const onClickCreateNewFeedbackGallery = () => {
    // 즉시 API 호출 대신, pending 상태로 설정하여 dashboard에 임시 카드 표시
    setPendingFeedbackGallery({
      dashboardId: props.dashboardId,
      rowIndex: props.rowCount ?? 0,
      feedbacksSetting: {
        filter_set: getDefaultFilterSet(),
        title: getFeedbackGalleryTitle(
          FEEDBACK_GALLERY_DEFAULT_TITLE,
          replaceFeedbackTerminology,
        ),
        sort_by: 'date',
        order_by: 'desc',
      },
    });
    setEditingState(true);
  };
  return (
    <>
      <CenterFlex
        height={props.height}
        d="column"
        f={1}
        g={12}
        style={{
          backgroundColor: color.gray200,
          borderRadius: '16px',
        }}
      >
        <AddChartDashboardMenu
          currentCharts={props.currentCharts}
          actions={{
            onClickCreateNewFeedbackGallery,
          }}
          anchor={<IconButton icon={<PlusOutlined />} sizeType="s" />}
          onAnchorClickAction={() => {
            track(AMP_KEYS.DASHBOARD_CARD_EMPTY_CLICK);
          }}
        />

        <Typo type="body2" weight="r" style={{ textAlign: 'center' }}>
          Click here to add
        </Typo>
      </CenterFlex>
    </>
  );
};

export default DashboardAddChartCard;
